// ==============================|| OVERRIDES - PAPER ||============================== //

export default function Paper(borderRadius: number) {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderColor: '#e6e6e6'
        },
        rounded: {
          borderRadius: `${borderRadius}px`,
          boxShadow: '0 14px 38px rgba(1, 0, 1, 0.06)'
        }
      }
    }
  };
}
